import React from 'react'
import PropTypes from 'prop-types'
import { Spin, List, Checkbox, Button } from 'core/components/ui'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

const Picture = styled.span`
  padding: 0 0.2rem;
`
const LinkButton = styled(Button)`
  span {
    text-decoration: underline;
  }
`
const DamageList = props => {
  const { intl } = props

  return (
    <>
      {props.loading ? (
        <div style={{ textAlign: 'center' }}>
          <Spin />
        </div>
      ) : (
        <List
          rows={0}
          dataSource={props.defaults.defects}
          renderItem={item => {
            const { defectWording } = item
            const isSelected = !props.damages
              ? false
              : props.damages.filter(el => el.id === item.id).length > 0
            return (
              <List.Item>
                <Checkbox checked={isSelected} onChange={() => props.onChangeSectionDefects(item)}>
                  {defectWording}
                </Checkbox>
                {isSelected && (
                  <LinkButton type="link" onClick={() => props.handleShowDamagePicturesModal(item)}>
                    {intl.formatMessage({
                      id:
                        !props.getDefectById(item.id).pictures ||
                        props.getDefectById(item.id).pictures.length === 0
                          ? 'tradeIn-defaults-add-visual'
                          : 'tradeIn-defaults-manage-visuals'
                    })}
                    {props.getDefectById(item.id).pictures &&
                      props.getDefectById(item.id).pictures.length > 0 && (
                        <Picture>({props.getDefectById(item.id).pictures.length})</Picture>
                      )}
                  </LinkButton>
                )}
              </List.Item>
            )
          }}
        />
      )}
    </>
  )
}
DamageList.defaultProps = {
  onSelect: null
}

DamageList.propTypes = {
  section: PropTypes.shape(),
  onSelect: PropTypes.func,
  loading: PropTypes.bool,
  getDefectById: PropTypes.func,
  handleShowDamagePicturesModal: PropTypes.func,
  onChangeSectionDefects: PropTypes.func,
  defaults: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()).isRequired,
    PropTypes.shape().isRequired
  ]),
  damages: PropTypes.arrayOf(PropTypes.shape()),
  intl: PropTypes.shape().isRequired
}

export default injectIntl(DamageList)
